import Stack, { StackProps } from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ReactNode } from 'react';

export type PageTitleProps = Omit<StackProps, 'title'> & {
  title: ReactNode;
  subtitle?: ReactNode;
};

export function PageTitle({ title, subtitle, ...stackProps }: PageTitleProps) {
  return (
    <Stack spacing={0} direction="column" {...stackProps}>
      <Typography
        data-testid="page-title"
        fontWeight={600}
        variant="h5"
        component="h1"
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          data-testid="page-subtitle"
          color="text.secondary"
          variant="body2"
        >
          {subtitle}
        </Typography>
      )}
    </Stack>
  );
}
